import React from 'react';
import './StageProgress.css';
import useRaceStore from '../../store/raceStore';
import useRaceData from '../../hooks/useRaceData';

/**
 * StageProgress component
 * Shows a visual representation of race stages and progress
 */
const StageProgress = () => {
  // Get race data from store
  const raceData = useRaceData();
  const currentStage = useRaceStore(state => state.currentStage);
  const stageProgress = useRaceStore(state => state.stageProgress);
  // Genel ilerleme bilgisi (gerekirse kullanılabilir)
  // const overallProgress = useRaceStore(state => state.overallProgress);
  const recordBoat = useRaceStore(state => state.recordBoat);
  
  // If data is still loading, show a simplified view
  if (raceData.isLoading) {
    return (
      <div className="stage-progress loading">
        <div className="stage-progress-header">
          <div className="stage-title">Yükleniyor...</div>
        </div>
      </div>
    );
  }
  
  // Konum adlarını düzenle
  const getLocationName = (location) => {
    // Konum adlarını gerçek adlarla değiştir
    const locationMap = {
      'START HATTI (Hopa Limanı)': 'Hopa',
      'CHECK POINT-1 SİNOP': 'Sinop',
      'CHECK POINT-2 BOĞAZLAR GİRİŞ': 'Boğazlar',
      'CHECK POINT-3 ÇANAKKALE BOĞAZI ÇIKIŞI': 'Çanakkale',
      'CHECK POINT-4 KNİDOS GEÇİSİ': 'Knidos',
      'CHECK POINT KIBRIS': 'Kıbrıs',
      'FİNİSH HATTI (İskenderun)': 'İskenderun'
    };
    
    return locationMap[location] || location;
  };
  
  // Prepare stage data for display
  const stages = recordBoat.stages.map((stage, index) => {
    const stageNumber = index + 1;
    
    // Konumların gerçek adlarını kullan
    const fromName = getLocationName(stage.from);
    const toName = getLocationName(stage.to);
    const stageName = `${fromName} → ${toName}`;
    const distance = stage.distance_nm; // Mesafeyi ekle
    
    // Calculate completion percentage for this stage
    let completed = 0;
    if (stageNumber < currentStage) {
      completed = 1; // Earlier stages are fully completed
    } else if (stageNumber === currentStage) {
      completed = stageProgress; // Current stage is partially completed
    }
    
    return {
      number: stageNumber,
      name: stageName,
      distance: distance,
      completed: completed
    };
  });
  

  
  // Format percentage for display
  const formatPercent = (value) => {
    return (value * 100).toFixed(1);
  };
  
  return (
    <div className="stage-progress">
      <div className="stage-progress-header">
        <div className="stage-title">
          {stages[currentStage - 1] && (
            <>
              <span className="stage-name">{stages[currentStage - 1].name}</span>
              <span className="stage-distance">{stages[currentStage - 1].distance} NM</span>
            </>
          )}
        </div>
        <div className="overall-progress">
          <span className="progress-label">Toplam:</span>
          <span className="progress-value">≈ {recordBoat.race_info.total_distance_nm} NM</span>
        </div>
      </div>
      
      <div className="stage-indicators">
        {stages.map((stage) => (
          <div 
            key={stage.number} 
            className={`stage-indicator ${stage.completed === 1 ? 'completed' : 
              (stage.number === currentStage ? 'current' : 'upcoming')}`}
          >
            <div className="stage-info">
              <div className="stage-name">{stage.name}</div>
              <div className="stage-distance">{stage.distance} NM</div>
            </div>
            <div className="stage-progress-bar">
              <div 
                className="stage-progress-fill"
                style={{ width: `${stage.number === currentStage ? formatPercent(stage.completed) : stage.completed === 1 ? '100' : '0'}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StageProgress;
